import { AcaoIndicativoNascimento } from '../../../api/indicativoNascimentoAPI';

export interface OpcaoPergunta {
  valor: string;
  label: string;
  encerraFluxo?: boolean;
  proximaEtapa?: 'compareca-ao-cras' | 'compareca-ao-cras-inclusao' | 'conclusao';
  codigoAcao?: AcaoIndicativoNascimento;
}

export interface CampoPergunta {
  id: string;
  label: string;
  placeholder?: string;
  somenteLeitura?: boolean;
  avisoSomenteLeitura?: string;
  checkboxNaoSei?: boolean;
  checkboxLabel?: string;
}

export interface Pergunta {
  id: string;
  titulo: (nomeCrianca: string, nomeRF: string) => string;
  descricao?: string;
  tipo: 'opcoes' | 'inputs';
  exibir?: boolean;
  opcoes?: OpcaoPergunta[];
  campos?: CampoPergunta[];
}

export const PERGUNTAS: Pergunta[] = [
  {
    id: 'deficiencia',
    tipo: 'opcoes',
    exibir: true,
    titulo: (nome) => `${nome} tem alguma deficiência permanente?`,
    descricao: 'Essas informações nos ajudam a oferecer atendimentos e políticas mais adequadas.',
    opcoes: [
      { valor: 'sim', label: 'Sim', encerraFluxo: true, proximaEtapa: 'compareca-ao-cras-inclusao', codigoAcao: AcaoIndicativoNascimento.CRIANCA_EH_PCD },
      { valor: 'nao', label: 'Não' },
    ],
  },
  {
    id: 'sexo',
    tipo: 'opcoes',
    exibir: true,
    titulo: (nome) => `Qual o sexo de ${nome}?`,
    opcoes: [
      { valor: 'feminino', label: 'Feminino' },
      { valor: 'masculino', label: 'Masculino' },
    ],
  },
  {
    id: 'parentesco',
    tipo: 'opcoes',
    exibir: true,
    titulo: (nome, nomeRF) => `Qual a relação de parentesco de ${nome} com você (${nomeRF})?`,
    opcoes: [
      { valor: 'filho', label: 'Filho(a)' },
      { valor: 'enteado', label: 'Enteado(a)' },
      { valor: 'neto_bisneto', label: 'Neto(a) ou bisneto(a)' },
      { valor: 'irmao', label: 'Irmão ou irmã' },
      { valor: 'outro_parente', label: 'Outro parente' },
      { valor: 'nao_parente', label: 'Não parente' },
    ],
  },
  {
    id: 'cor_raca',
    tipo: 'opcoes',
    exibir: true,
    titulo: (nome) => `Neste momento, qual a cor ou raça de ${nome}?`,
    descricao: 'Essa identificação pode mudar, principalmente no caso de crianças recém-nascidas.',
    opcoes: [
      { valor: 'branca', label: 'Branca' },
      { valor: 'preta', label: 'Preta' },
      { valor: 'amarela', label: 'Amarela' },
      { valor: 'parda', label: 'Parda' },
      { valor: 'indigena', label: 'Indígena' },
    ],
  },
  {
    id: 'filiacao',
    tipo: 'inputs',
    exibir: true,
    titulo: (nome) => `Confirme a filiação de ${nome}`,
    campos: [
      {
        id: 'filiacao1',
        label: 'Filiação 1 (ou nome completo da mãe)',
        placeholder: 'Nome da mãe indisponível',
        somenteLeitura: true,
        avisoSomenteLeitura: 'Essa filiação não pode ser alterada. Caso o nome esteja incorreto, procure o posto de atendimento',
      },
      {
        id: 'filiacao2',
        label: 'Filiação 2',
        placeholder: 'Nome do PAI',
        checkboxNaoSei: true,
        checkboxLabel: 'Não sei o nome',
      },
    ],
  },
];

export const PERGUNTAS_VISIVEIS = PERGUNTAS.filter((p) => p.exibir !== false);
